import { Box, Link, Typography } from '@packages/shared';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { getLocalizedPath } from '@packages/shared/src/utils/getLocalizedPath/getLocalizedPath';
import { defineMessages, useIntl } from 'react-intl';

export const messages = defineMessages({
  standardAgb: {
    id: 'BusinessTerms.LegalText',
    defaultMessage:
      'Es gelten die <conditions>Allgemeinen Geschäftsbedingungen</conditions> von Baur auch hinsichtlich des <revocation>Widerrufsrechts</revocation>.',
  },
  agbCheckbox: {
    id: 'BusinessTerms.AgbCheckbox',
    defaultMessage: `JA, ich stimme den <agb>AGB</agb> für bereits getätigte und künftige Bestellungen zu.\n
      Ich nehme die Bestimmungen zum <agb>Widerrufsrecht</agb> und die <dataProtection>Datenschutzhinweise</dataProtection> zur Kenntnis.`,
  },
  agbUnchecked: {
    id: 'BusinessTerms.AgbCheckbox.uncheckedError',
    defaultMessage:
      'Bitte stimmen Sie unseren AGB zu, indem Sie das entsprechende Kontrollkästchen markieren.',
  },
  weeeTakeBackMessage: {
    id: 'BusinessTerms.WEEETakeBackAddition',
    defaultMessage: 'Über die gesetzliche Möglichkeit zur Altgeräte-Rücknahme wurde informiert.',
  },
});

export const BusinessTerms: React.FC = () => {
  const {
    order: { externalUrls },
  } = useConfig();
  const { locale, formatMessage } = useIntl();

  return (
    <Box
      sx={{
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderTopColor: 'grey.main',
        p: 1,
        textAlign: 'center',
        color: 'text.darkTransparent',
        bgcolor: 'grey.light',
      }}
    >
      <Typography data-testid="business-terms-text" variant="body3">
        {formatMessage(messages.standardAgb, {
          conditions: (chunks: React.ReactNode) => (
            <Link
              href={getLocalizedPath(externalUrls.agb, locale)}
              target="_blank"
              color="text.darkTransparent"
            >
              {chunks}
            </Link>
          ),
          revocation: (chunks: React.ReactNode) => (
            <Link
              href={getLocalizedPath(externalUrls.revocation, locale)}
              target="_blank"
              color="text.darkTransparent"
            >
              {chunks}
            </Link>
          ),
        })}
      </Typography>
      {/* TODO }
        <span>{weeeTakeBackAddition}</span>
      { */}
    </Box>
  );
};
